import {Component} from '@angular/core';
import {IconComponent} from '../../shared/icon/icon.component';

@Component({
  selector: 'app-error-page',
  standalone: true,
  imports: [IconComponent],
  styleUrls: ['./error-page.component.scss'],
  host: {
    'class': 'd-flex align-items-center justify-content-center'
  },
  template: `
    <main
      class="error-card d-flex flex-column align-items-center justify-content-center w-100 text-center bg-white"
      aria-labelledby="error-title"
    >
      <app-icon class="error-icon mb-4" icon="error" aria-hidden="true" />
      <h1 id="error-title" class="m-0 mb-3">Something went wrong</h1>
      <p class="m-0 mb-2 lh-base">We couldn't complete your request.</p>
      <p class="m-0 mb-2 lh-base">
        Try again. If the problem continues, visit the
        <a class="help-desk-link" href="https://www.liberty.edu/ITHelpDesk" target="_blank" rel="noopener noreferrer">Liberty IT Help Desk</a>.
      </p>
      <a class="custom-button-large-primary-dark-blue mt-4" href="/">Try again</a>
    </main>
  `
})
export class ErrorPageComponent {}
